export default __webpack_public_path__ + "static/media/logo.35e4e3f8.png";